<template>
  <motlet :options="motletOptions">
    <template #content>
      <v-row class="h-100">
        <v-col col="6">
          <v-card class="card-wrap">
            <v-card-title>Running Work Process</v-card-title>
            <v-card-text class="chart-area">
              <!-- eslint-disable-next-line prettier/prettier -->
              <running-work-process
                :system="system"
                :items="instances"
                :values="runningWorkProcess"
                :formatter="formatter.runningWorkProcess"
                :selected-descendant.sync="selectedDescendant"
                :contextmenu="contextmenuChart"
              />
            </v-card-text>
          </v-card>
        </v-col>
        <v-col col="6">
          <v-card class="card-wrap">
            <v-card-title>Extended Memory</v-card-title>
            <v-card-text class="chart-area">
              <!-- eslint-disable-next-line prettier/prettier -->
              <extended-memory
                :system="system"
                :items="instances"
                :values="extendedMemory"
                :formatter="formatter.extendedMemory"
                :max="100"
                :selected-descendant.sync="selectedDescendant"
                :contextmenu="contextmenuChart"
              />
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </template>
    <template #menu>
      <contextmenu :options="contextmenuParam"></contextmenu>
    </template>
  </motlet>
</template>

<script>
import { cloneDeep } from 'lodash';
import instanceable from './mixins/instanceable';
import contextmenuable from './mixins/contextmenuable';
import RunningWorkProcess from '../chart/BarVerticalStack.vue';
import ExtendedMemory from '../chart/BarVertical.vue';

export default {
  mixins: [instanceable, contextmenuable],
  components: {
    RunningWorkProcess,
    ExtendedMemory,
  },
  data() {
    return {
      motletOptions: {
        id: 'overview/system/abap/InstanceSummary',
        title: 'Instance Summary',
      },
      messageSequence: 0,
      values: {
        runningWorkProcess: {},
        extendedMemory: {},
      },
      runningWorkProcess: [],
      extendedMemory: {},
      formatter: {
        runningWorkProcess: params => {
          const sum = params.reduce((acc, item) => acc + item, 0);
          return `${params[0]} / ${sum}`;
        },
        extendedMemory: param => `${param.value} %`,
      },
      contextmenuUrl: '/views/detailview/abap/process',
      selectedDescendant: {},
    };
  },
  watch: {
    instances: {
      handler: 'changeInstancesHandler',
    },
  },
  methods: {
    contextmenuChart(event) {
      this.onContextmenuChart(event, this.selectedDescendant);
    },
    // BEGIN::Removed.by.KWShin.
    // 어차피 Buffered data의 마지막 건만 필요한 경우
    // 구독 시 buffer() handler를 안 보내면
    // 서버에서 Buffered data의 마지막 건만 every() handler로 보내도록 수정함.
    // wsBufferedDataHandler(key, responses, every) {
    //   responses.forEach(response => {
    //     const last = response.length ? response[response.length - 1] : { data: [], ctime: '', empty: true };
    //     every(key, last.data, last.ctime, last.empty);
    //   });
    // },
    // FINISH::Removed.by.KWShin.
    wsDataHandler(key, response) {
      ++this.messageSequence;

      // 인스턴스 별 초기화
      if (key.name == 'rawWorkprcs') {
        this.values.runningWorkProcess[key.instId] = {
          runningCount: 0,
          rest: 0,
          totalCount: 0,
        };
      } else if (key.name == 'rawMemory') {
        this.values.extendedMemory[key.instId] = 0.0;
      }

      response.forEach(res => {
        if (key.name == 'rawWorkprcs') {
          this.values.runningWorkProcess[key.instId].totalCount++;
          if (!!res.wpStatus && res.wpIstatus == 4) this.values.runningWorkProcess[key.instId].runningCount++;
        } else if (key.name == 'rawMemory') {
          if (res.areaName == 'EXTENDED MEMORY') this.values.extendedMemory[key.instId] = parseFloat(res.currUsedP).toFixed(2);
        }
      });

      // 모든 인스턴스 값이 지정되었을 경우
      if (this.messageSequence == this.instances.length) {
        if (key.name == 'rawWorkprcs') {
          Object.keys(this.values.runningWorkProcess).forEach(instId => {
            this.values.runningWorkProcess[instId].rest = this.values.runningWorkProcess[instId].totalCount - this.values.runningWorkProcess[instId].runningCount;
            delete this.values.runningWorkProcess[instId].totalCount;
          });
          this.runningWorkProcess = this.instances.map(instance => {
            return [
              {
                name: 'runningCount',
                value: this.values.runningWorkProcess[instance.id].runningCount,
                color: instance.color,
              },
              {
                name: '_empty',
                value: this.values.runningWorkProcess[instance.id].rest,
                color: '#6B717D',
              },
            ];
          });
        }
        this.extendedMemory = cloneDeep(this.values.extendedMemory);
        this.messageSequence = 0;
      }
    },
    subscribe() {
      this.$websocket.realtime.subscribe({
        requests: this.instances.map(instance => ({
          key: { name: 'rawWorkprcs', sstmId: instance.systemId, instId: instance.id },
          fields: ['wpIstatus', 'wpStatus'],
          handler: {
            // buffer: this.wsBufferedDataHandler,
            every: this.wsDataHandler,
          },
        })),
      });
    },
    sendMessage() {
      this.$websocket.realtime.send({
        requests: this.instances.map(instance => ({
          key: { name: 'rawMemory', sstmId: instance.systemId, instId: instance.id },
          fields: ['areaName', 'currUsedP'],
          handler: {
            // buffer: this.wsBufferedDataHandler,
            every: this.wsDataHandler,
          },
        })),
      });
    },
    initialize() {
      this.messageSequence = 0;
      // value init
      Object.keys(this.values).forEach(key => (this.values[key] = {}));
      this.runningWorkProcess = [];
      this.extendedMemory = {};

      // websoket message init
      this.wsRequestMessages = {};
    },
    changeInstancesHandler() {
      this.initialize();
      this.sendMessage();
      this.subscribe();
    },
  },
};
</script>

<style scoped>
.chart-area {
  height: calc(100% - 37px);
}
</style>
